import { supabase } from '@/lib/supabase'

// Frontend gate (UX only; the database and the edge functions enforce it too). A platform admin is
// marked in app_metadata by scripts/make-platform-admin.mjs and must have passed the second factor
// in this session. No email address counts (spec 009 FR-006).

export async function adminApi<T = unknown>(body: Record<string, unknown>): Promise<T> {
  const { data, error } = await supabase.functions.invoke('admin-api', { body })
  if (error) {
    const ctx = (error as { context?: Response }).context
    let msg = error.message
    try { if (ctx) { const j = await ctx.json(); if (j?.error) msg = j.error } } catch { /* */ }
    throw new Error(msg)
  }
  return data as T
}

export async function isPlatformAdmin(): Promise<boolean> {
  try {
    const { data, error } = await supabase.rpc('is_platform_admin')
    return !error && data === true
  } catch { return false }
}

/** True when the account is marked as a platform admin, before the second factor. */
export async function isMarkedPlatformAdmin(): Promise<boolean> {
  const { data } = await supabase.auth.getUser()
  return (data.user?.app_metadata as { platform_admin?: boolean } | undefined)?.platform_admin === true
}
